var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-data-table", {
            staticClass: "log-table",
            staticStyle: { "flex-grow": "1" },
            attrs: {
              items: _vm.logs,
              columns: _vm.columns,
              "selected-items": _vm.selected,
              "order-column": _vm.orderedColumnProperty,
              "order-direction": _vm.orderAscending,
              "column-resize-handle": "",
            },
            on: {
              order: function ($event) {
                return _vm.onOrder($event)
              },
              "item-clicked": function ($event) {
                return _vm.openLog($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }